export enum InvoiceStatus {
  Failed = 'failed',
  RegisterError = 'register_error',
  Error = 'error',
  Canceled = 'canceled',
  Created = 'created',
  Issued = 'issued',
  SentEmail = 'sent_email',
  Pending = 'pending',
  None = 'none',
  Draft = 'draft',
  WaitingForSplit = 'waiting_for_split',
  WaitingCalculateTaxes = 'WaitingCalculateTaxes',
  Unknown = 'unknown'
}

